import styled from 'styled-components';
import { BREAKPOINTS } from 'constants/breakpoints';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

const StyledStickyContainer = styled.div`
  position: sticky;
  top: 76.78px;
  background: white;
  z-index: 9;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    position: relative;
    top: 0;
    overflow-y: clip;
    overflow-x: scroll;
    white-space: nowrap;
  }
`;

export { StyledStickyContainer };
